export default "__VITE_ASSET__DexQd_gk__"